import { NavLink } from "react-router-dom";

import { cn } from "@/lib/cn";
import { CawambaMark } from "@/components/CawambaMark";

export type BrandMarkVariant = "full" | "glyph";

export interface BrandMarkProps {
  /** Destination for the brand link. Defaults to root. */
  to?: string;
  /**
   * `full` renders the wordmark used in the desktop sidebar. `glyph` renders
   * a 32x32 monogram for the mobile header where horizontal room is at a
   * premium.
   */
  variant?: BrandMarkVariant;
  className?: string;
}

/**
 * App brand link. Centralised so the desktop sidebar and mobile header don't
 * drift apart — each renders the appropriate `variant` of the same component.
 */
export function BrandMark({
  to = "/",
  variant = "full",
  className,
}: BrandMarkProps) {
  if (variant === "glyph") {
    return (
      <NavLink
        to={to}
        aria-label="Cawamba home"
        className={cn(
          "inline-flex h-8 w-8 items-center justify-center rounded-md",
          "text-text transition-colors duration-fast ease",
          "hover:text-accent",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent",
          className,
        )}
      >
        <CawambaMark className="h-7 w-7" title={null} />
      </NavLink>
    );
  }
  return (
    <NavLink
      to={to}
      aria-label="Cawamba home"
      className={cn(
        "inline-flex items-center gap-2 rounded-sm text-text",
        "font-display text-2xl font-medium tracking-tight",
        "transition-colors duration-fast ease",
        "hover:text-accent",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent",
        className,
      )}
    >
      <CawambaMark className="h-7 w-7 shrink-0" title={null} />
      <span>Cawamba</span>
    </NavLink>
  );
}
